import { render, staticRenderFns } from "./VatSettingsLoader.vue?vue&type=template&id=1d89f258&scoped=true&"
import script from "./VatSettingsLoader.vue?vue&type=script&lang=js&"
export * from "./VatSettingsLoader.vue?vue&type=script&lang=js&"
import style0 from "./VatSettingsLoader.vue?vue&type=style&index=0&id=1d89f258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d89f258",
  null
  
)

export default component.exports